<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <el-button :to="{ name: 'portals' }" type="primary" class="inline">
        {{ $t('portals.list.goBackToDiffusionList') }}
      </el-button>
    </template>
    <div v-loading="loading"
         :element-loading-text="$t('portals.list.chargementDonnees')">
    <el-form @submit.prevent.native="fetchList">
      <ubi-panel style="background-color: #EBF3F2;">
        <ubi-search-container
            :filters="filters"
            @filter="doFilter"
            :defaultFilter="this.filter.preset"
            v-on:resetfilter="doFilter('reset')"
            :more-opened="filter.advanced"
            @update:more-opened="advanced => setFilter({ advanced })">
          <el-form-item :label="$t('general.filters.titleReference')">
            <el-input type="text" @input="setSearch" :value="filter.search"
                      :placeholder="$t('general.filters.titlePlaceholder')"/>
          </el-form-item>
          <el-form-item :label="$t('general.filters.date')">
            <el-date-picker
                    type="daterange"
                    :value="filter.dateCreationGt || filter.dateCreationLt? [
                        filter.dateCreationGt || undefined,
                        filter.dateCreationLt || undefined
                      ] : null"
                    :start-placeholder="$t('general.filters.dateCreationStart')"
                    :end-placeholder="$t('general.filters.dateCreationEnd')"
                    @input="
                        dates => addFilter({ dateCreationGt: dates? dates[0] : null, dateCreationLt: dates ? dates[1] : null})
                      "
                    format="dd/MM/yyyy"
                    :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </ubi-search-container>
      </ubi-panel>
    </el-form>
    <ubi-panel>
      <ubi-list-header slot="header"
                       :limits="limits"
                       :page.sync="page"
                       :limit.sync="limit"
                       :total="nbResults"
                       :sort.sync="sort"
                       :sortProperties="sortProperties"></ubi-list-header>
      <!--			<el-button type="mini" slot="actions" @click="exporter">Exporter les résultats</el-button>-->
      <ubi-list-footer slot="footer" :limits="limits" :page.sync="page" :limit.sync="limit"
                       :total="nbResults"></ubi-list-footer>
      <el-table ref="table" :data="annonces">

        <el-table-column :label="$t('portals.list.columnDiffused')" min-width="50" align="center">
          <template v-slot="{ row: result }">
            <em class="el-icon-success text-success mr-2"  style="font-size:1.9em;" v-if="result.nbPortailsActifs > 0"  />
          </template>
        </el-table-column>

        <el-table-column :label="$t('portals.list.columnPicture')" min-width="100" align="center">
          <template v-slot="{ row: result }">
            <img width="80" v-if="result.photoPrincipale != null && result.photoPrincipale != false"
                 alt=""
                 :src="result.photoPrincipale.url_miniature"
                 :srcset="result.photoPrincipale.url_miniature"
            />
            <div v-else>
              <ubi-icon class="no-photo" name="camera" size='60'/>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('portals.list.columnReference')" min-width="120">
          <template v-slot="{ row: result }">
            <router-link :to="{ name: 'post-view', params: { post: result.id } }">
              <strong>{{result.reference}}</strong>
            </router-link>
            <br>
            {{result.titre}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('portals.list.columnCity')" min-width="80">
          <template v-slot="{ row: result }">
            <div v-if="result.donnees.ville">{{result.donnees.ville.valeur}} <br>
            {{result.donnees.code_postal.valeur}}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('portals.list.columnPrice')" min-width="60">
          <template v-slot="{ row: result }">
            {{result.prix}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('portals.list.nbLotsBroadcasted')" min-width="80" v-if="isPromoteur && filter.annonceParente == null">
          <template v-slot="{ row: result }">
            <a>
              {{result.nbLotsCoches}}/{{result.nbLots}}
            </a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('portals.list.columnEditDiffusion')" min-width="80" align="center">
          <template v-slot="{ row: result }">
            <router-link
                :to="{name :'portals-selection-post', params: { post : result.id }}"
            >
              <em class="el-icon-edit"/>
            </router-link>

          </template>
        </el-table-column>
      </el-table>
    </ubi-panel>
    </div>
  </ubi-page-container>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";
.el-loading-spinner{
  top:10%!important;
}
</style>

<script>
import moment from 'moment'
import { mapGetters, mapMutations, mapState } from 'vuex'
import PieChart from '@/services/piechart'
import { Collapse, CollapseItem, Divider } from 'element-ui'
import { exportXlsPosts, getNbTotalLotsProgramme, getPosts, getNbTotalLotsCochesProgramme } from '../../services/posts'

export default {
  name: 'PortalsListPosts',
  inject: ['browserContext'],
  components: {
    PieChart,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider
  },
  data () {
    return {
      loading: false,
      offset: 0,
      limits: [10, 10 * 2, 10 * 5],
      enTete: null,
      nbResults: 0,
      sortProperties: {
        R: this.$t('general.sort.reference'),
        T: this.$t('general.sort.title'),
        "-DC": this.$t('general.sort.creationDate')
        // "-CTM": this.$t("Contacts"),
      },
      nbContactsGeneres: 0,
      nbContactsGeneresTotal: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      nbPortailsActifs: 0,
      annonces: null,
      graphData: {},
      filters: [
        { value: 'reset', label: this.$t('general.filters.allAds') }
        // {value: "published", label: this.$t("general.filters.diffusedAds")},
        // {value: "notPublished", label: this.$t("general.filters.noDiffusedAds")},
      ]
    }
  },
  computed: {
    ...mapState('posts', ['filter', 'results']),
    ...mapGetters(['getPickerOptionsShortcuts']),
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        window.scrollTo(0, 0)
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
        return this.setPage(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setSort(value)
      }
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    }
  },
  created () {
    // Définir le tri par défaut sur référence
    this.setSort('R')
  },
  methods: {
    async exporter () {
      const res = await exportXlsPosts(this.filter, null, true, this.$t('portals.list.filenameExportPortals'))
      this.$message(res)
      this.loading = false
    },
    convertDate: function (date) {
      return 'Le ' + moment(date).format('DD/MM/YYYY à hh:mm:ss')
    },
    ...mapMutations('posts', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'resetFilter'
    ]),
    handleClose (done) {
      this.$confirm(this.$t('general.exitConfirmation'))
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    doFilter (type) {
      switch (type) {
        case 'reset':
          this.resetFilter()
          break
              // case "published":
              // 	this.setFilter({
              // 		withContacts: true,
              // 		sort: 'R',
              // 		beforeContacts: this.filter.beforeContacts,
              // 		afterContacts: this.filter.afterContacts,
              // 		search: this.filter.search
              // 	});
              // 	break;
              // case "notPublished":
              // 	this.setFilter({
              // 		activeOnly: true,
              // 		sort: 'R',
              // 		beforeContacts: this.filter.beforeContacts,
              // 		afterContacts: this.filter.afterContacts,
              // 		search: this.filter.search
              // 	});
              // 	break;
      }
      this.fetchList()
    },
    async getProgramNbLots (parentId) {
      const nbLots = await getNbTotalLotsProgramme(parentId)
      return nbLots
    },
    async getProgramNbLotsCoches (parentId) {
      const nbLots = await getNbTotalLotsCochesProgramme(parentId)
      return nbLots
    },
    async getInfosLots (annonces) {
      const tabAnnonces = []
      annonces.forEach(async function (annonce) {
        if (annonce.id) {
          const nbLotsProgramme = await this.getProgramNbLots(annonce.id)
          annonce.nbLots = nbLotsProgramme
          const nbLotsCochesProgramme = await this.getProgramNbLotsCoches(annonce.id)
          annonce.nbLotsCoches = nbLotsCochesProgramme
        } else {
          annonce.nbLots = 0
          annonce.nbLotsCoches = 0
        }
        tabAnnonces.push(annonce)
      }, this)
      return tabAnnonces
    },
    async fetchList () {
      // No need to interrupt promises when the router changes...
      this.loading = true
      const annoncesContacts = await getPosts(this.filter, null, null, this.sitimmoUser.univers)
      if (annoncesContacts.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      this.nbResults = annoncesContacts.total

      // TODO: il manque surement le check sur promoteur et la pagination qui doit sauter, a voir si on refait en mode rapide comme j'ai fait au dessus ou si on passe par les "setResults()"
      if (this.isPromoteur) {
        this.annonces = await this.getInfosLots(annoncesContacts.list)
      } else {
        this.annonces = annoncesContacts.list
      }

      this.loading = false
    }
  }

}
</script>
